import React from 'react';
import Typography from '@material-ui/core/Typography';
import AmountField from 'app/main/components/AmountField';
import AmountAndPercentageField from 'app/main/components/AmountAndPercentageField';
import { formatMoney } from 'app/main/utils/numberUtils';

function ProjectedFees(props) {
  const { form, classes, projectedTotalAmount, checkPermissions, authRoles, handleChange } = props;

  return (
    <>
      <div className="flex items-center my-20">
        <Typography className={classes.feesTitle} component="h2">
          <b>Projected fees -</b>
        </Typography>
        <Typography component="h2" className="ml-4">
          <span>
            <b>Total: </b>
          </span>
          {`$ ${formatMoney(projectedTotalAmount, 2)}`}
        </Typography>
      </div>
      <AmountField
        disabled
        label="Origination Fee"
        id="projectedFees.originationFee"
        className={classes.field}
        value={form.projectedFees.originationFee}
        onChange={handleChange}
      />
      {checkPermissions(authRoles.closingEventsEditProjectedFees) && (
        <>
          <AmountAndPercentageField
            id="projectedFees.discount"
            label="Discount"
            className={`${classes.field} ${classes.fieldPercentage}`}
            total={form.loan.loanAmount}
            value={form.projectedFees.discount}
            onChange={handleChange}
          />
          <AmountAndPercentageField
            id="projectedFees.yieldSpread"
            label="Yield Spread"
            className={`${classes.field} ${classes.fieldPercentage}`}
            total={form.loan.loanAmount}
            value={form.projectedFees.yieldSpread}
            onChange={handleChange}
          />
        </>
      )}
      <AmountField
        disabled
        label="Appraisal"
        id="projectedFees.appraisal"
        className={classes.field}
        value={form.projectedFees.appraisal}
        onChange={handleChange}
      />
      <AmountField
        disabled
        label="Credit Report"
        id="projectedFees.creditReport"
        className={classes.field}
        value={form.projectedFees.creditReport}
        onChange={handleChange}
      />
      <AmountField
        disabled
        label="Processing Fee"
        id="projectedFees.processingFee"
        className={classes.field}
        value={form.projectedFees.processingFee}
        onChange={handleChange}
      />
      <AmountField
        disabled
        label="Underwriting Fee"
        id="projectedFees.underwritingFee"
        className={classes.field}
        value={form.projectedFees.underwritingFee}
        onChange={handleChange}
      />
      <AmountField
        disabled
        label="Broker Fee"
        id="projectedFees.brokerFee"
        className={classes.field}
        value={form.projectedFees.brokerFee}
        onChange={handleChange}
      />
    </>
  );
}

export default ProjectedFees;
